import { gql } from '@apollo/client';

import baseFields from '../base';
import TRANSACTION_TYPES_FRAGMENT from './transactionTypes';

const SERVICE_TYPES_FRAGMENT = gql`
  ${TRANSACTION_TYPES_FRAGMENT}
  fragment ServiceTypesFragment on ServiceType {
    ${baseFields}
    name
    description
    transactionTypes {
      ...TransactionTypesFragment
    }
  }
`;

export default SERVICE_TYPES_FRAGMENT;
